export const SET_FOIV_BIG_SUB_CATEGORIES_FETCHING = 'SET_FOIV_BIG_SUB_CATEGORIES_FETCHING';
export const SET_FOIV_BIG_SUB_CATEGORIES_ERROR = 'SET_FOIV_BIG_SUB_CATEGORIES_ERROR';
export const SET_FOIV_BIG_SUB_CATEGORIES = 'SET_FOIV_BIG_SUB_CATEGORIES';
export const CLEAN_FOIV_BIG_SUB_CATEGORIES = 'CLEAN_FOIV_BIG_SUB_CATEGORIES';
export const ABORT_FOIV_BIG_SUB_CATEGORIES_REQUEST = 'ABORT_FOIV_BIG_SUB_CATEGORIES_REQUEST';



// WEBPACK FOOTER //
// ./src/redux_related/FOIVBigSubCategories/actions.js